import { Component, inject, OnInit, signal, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngxs/store';
import { environmentAdmin } from '@lexplus-environments';
import { DmSidebarInset, DmSidebarMobileHeader, DmSidebarProvider, DmToaster } from '@digitale-menschen/component-library-angular';
import {
  ConfirmDialogComponent,
  injectMobileSidebarCloser,
  LanguageService,
  LexplusLogoComponent,
  ProfileState,
} from '@lexplus-shared-lib';
import { SidebarNavigationComponent } from './global/components/sidebar-navigation/sidebar-navigation.component';

// Mirrors dm-sidebar-provider's own (undocumented internal) cookie name, read
// synchronously so our collapsed-state styling starts correct on first render.
const SIDEBAR_STATE_COOKIE_NAME = 'dm_sidebar_state';

function readInitialSidebarOpenState(): boolean {
  const match = document.cookie.match(new RegExp(`(?:^|; )${SIDEBAR_STATE_COOKIE_NAME}=([^;]*)`));
  return match ? match[1] === 'true' : true;
}

@Component({
  imports: [
    RouterModule,
    DmToaster,
    DmSidebarProvider,
    DmSidebarInset,
    DmSidebarMobileHeader,
    LexplusLogoComponent,
    SidebarNavigationComponent,
    ConfirmDialogComponent,
  ],
  selector: 'lp-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly store = inject(Store);
  private readonly languageService = inject(LanguageService);

  private readonly sidebarProvider = viewChild<DmSidebarProvider>('sidebarProvider');

  protected readonly sidebarExpanded = signal(readInitialSidebarOpenState());

  protected readonly isLoggedIn = this.store.selectSignal(ProfileState.isLoggedIn);
  private readonly mobileSidebarCloser = injectMobileSidebarCloser(this.sidebarProvider);

  private readonly environmentAdmin = environmentAdmin;

  // Without it neither the remembered nor the browser language is ever applied.
  public ngOnInit(): void {
    this.languageService.initLanguageAndListeners();
  }

  protected onCloseMobileSidebar(): void {
    this.mobileSidebarCloser.close();
  }
}
